<div class="my-3">
  <div class="row m-0 justify-content-center">
    <div class="col-10 py-0">
      <div class="row m-0" [class.py-6]="!lstCatalogos">
        <app-loading-element
          [text]="'Cargando Catalogos'"
          *ngIf="!lstCatalogos"
        ></app-loading-element>
        <ng-container *ngFor="let catalogo of lstCatalogos; let i = index">
          <div class="md:col-4 py-0" style="margin-bottom: 20px">
            <div class="card p-0">
              <div class="row g-0">
                <div class="col-4 py-0 p-2 align-self-center box">
                  <img
                    [src]="catalogo.frontPageUrl"
                    [alt]="catalogo.name"
                    class="card-img"
                  />
                </div>
                <div class="col-8 py-0">
                  <div class="card-body py-1 pl-1">
                    <table style="font-size: 13px">
                      <tbody>
                        <tr>
                          <td colspan="2">
                            <h5>{{ catalogo.name }}</h5>
                          </td>
                        </tr>
                        <tr>
                          <td style="width: 110px">
                            <small class="text-muted">FECHA VIGENCIA: </small>
                          </td>
                          <td>
                            {{ catalogo.activationDate | date : 'dd/MM/yyyy' }}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <small class="text-muted"
                              >FECHA EXPIRACI&Oacute;N:
                            </small>
                          </td>
                          <td>
                            {{ catalogo.expirationDate | date : 'dd/MM/yyyy' }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="card-footer py-1 pl-1">
                    <button
                      class="btn"
                      (click)="verCatalogo(catalogo)"
                      style="background-color: #009579; color: #ffffff"
                    >
                      ver catalogo
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
